module.exports = __webpack_public_path__ + "img/schemeList03Display02.3082e26a.jpg";